module.exports = __webpack_public_path__ + "static/media/facebook.2355ed2b.webp";